import React from 'react';
import { useRouter } from 'next/router';

import {
  useTopUnderwritersContext,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopUnderwritersContext';

import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import {
  topCompaniesTablesCommonProps,
  getTopCompanyColumns,
} from '../common/tableConfigs';
import { getLeagueTableItemRoute } from '@/creditflowresearch/ui/components/league/LeagueTablePage/helpers';
import { getQueryString } from '@framework/router';
import { UNDERWRITER_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';

const TopUnderwriters = () => {
  const {
    query: {
      products,
      regions,
    },
  } = useRouter();
  const search = {
    products,
    regions,
  };
  const {
    collection,
    totalCount,
    page,
    perPage,
    paginate,
    isFetching,
    showVolume,
  } = useTopUnderwritersContext();

  return (
    <>
      { isFetching && <Spinner isVisible overlay /> }
      <LinkTable
        { ...topCompaniesTablesCommonProps }
        columns={ getTopCompanyColumns({
          showVolume,
          companyRole: UNDERWRITER_NAME,
        }) }
        data={ collection }
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        onPageChange={ (page) => paginate(page.selected) }
        isFetching={ isFetching }
        getRoutePath={ getLeagueTableItemRoute(getQueryString(search), UNDERWRITER_NAME) }
        emptyMessageText="No Top Underwriters during the selected period."
        paginatorDataTest="linkTablePaginatorUnderwriters"
        rowDataTest="linkTableRowUnderwriters"
      />
    </>
  );
};

export default TopUnderwriters;
